import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./SearchBarMobileFilterButton.module.scss";

SearchBarMobileFilterButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
};

type SearchBarMobileFilterButtonProps = {
  className?: string;
  children?: React.ReactNode;
  onClick?(): void;
};

export function SearchBarMobileFilterButton({
  className,
  children = null,
  onClick = () => {},
}: SearchBarMobileFilterButtonProps) {
  return (
    <div
      className={classnames(className, styles.container)}
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      {children}
    </div>
  );
}
